export enum BriefingImageFrameEnum {
    NO_FRAME = 'NO_FRAME',
    COLLAGE = 'COLLAGE',
}
